import React from 'react';
import { PageLayout } from '../../components/layout/PageLayout';

export default function Billing() {
  return (
    <PageLayout
      title="Electronic Invoicing"
      subtitle="Accelerate your cash flow with smart, automated invoice management and QuickBooks sync."
      badge="B2B OPTIMIZED"
      imageSrc="/products/art_billing_1776905114930.png"
    >
      <div className="mt-16 bg-white p-10 md:p-16 rounded-[2.5rem] border border-gray-100 shadow-sm relative overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-green-50 rounded-full blur-3xl -mr-20 -mt-20 pointer-events-none"></div>
        
        <div className="relative z-10 max-w-3xl">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-6">Bill Connect Ecosystem</h2>
          <p className="text-lg text-gray-600 mb-8">
            Why pay exorbitant fees for standalone invoicing software? Paygent’s Electronic Invoicing lets you email professional invoices that customers can pay with just a few clicks. 
          </p>
          
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-green-100 text-green-700 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-file-excel-2-line"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900">QuickBooks & Xero Sync</h4>
                <p className="text-gray-600 text-sm">Automatically reconcile paid invoices with your accounting software, eliminating manual data entry.</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-link"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900">Secure Payment Links</h4>
                <p className="text-gray-600 text-sm">Send dynamic QR codes or payment links via SMS and email to get paid faster.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
